/** @format */

export enum PlanOperationTypes {
    COMMENT = 'COMMENT',
    SUGGEST_ADD = 'SUGGEST_ADD',
    SUGGEST_REMOVE = 'SUGGEST_REMOVE',
    ADDED = 'ADDED',
    REMOVED = 'REMOVED',
}
